import store from '../store'
/**
 * @method 存储数据到localStorage中
 * @param {*key值} key
 * @param {*值} val
 */
export function setLocalValue (key, value) {
  key = 'local.' + key
  const currentTime = new Date().getTime()
  localStorage.setItem(key, JSON.stringify({
    value: value,
    time: currentTime,
  }))
}

/**
 * @method 获取localStorage中某个的数据
 * @param {*key值} key
 */
export function getLocalValue (key) {
  try {
    key = 'local.' + key
    const value = localStorage.getItem(key)
    if(!isEmpty(value)) {
      return JSON.parse(value).value
    } else {
      return ''
    }
  } catch (e) {
    console.log('从localStorage获取' + key + '失败: ' + e)
  }
}

/**
 * @method 移除localStorage中的某个数据
 * @param {*key值} key
 */
export function removeLocalValue (key) {
  key = 'local.' + key
  localStorage.removeItem(key)
}

/**
 * 判断对象为空
 * @param v
 * @return {boolean}
 */
export const isEmpty = (v) => {
  // console.log('typeof v ', v, typeof v)
  if(typeof v === 'undefined') {
    return true
  }
  if(v === undefined || v === 'undefined') {
    return true
  }
  if(v === null) {
    return true
  }
  if(v === '' || v === 'null') {
    return true
  }
  switch (typeof v) {
    case 'string' :
      if(v.trim().length === 0) {
        return true
      }
      break
    case 'boolean' :
      if(!v) {
        return true
      }
      break
    case 'object' :
      return undefined !== v.length && v.length === 0
  }
  return false
}

/**
 * 日期对象转为日期字符串
 * @param date 需要格式化的日期对象
 * @param sFormat 输出格式,默认为yyyy-MM-dd                         年：y，月：M，日：d，时：h，分：m，秒：s
 * @example  dateFormat(new Date())                                "2017-02-28"
 * @example  dateFormat(new Date(),'yyyy-MM-dd')                   "2017-02-28"
 * @example  dateFormat(new Date(),'yyyy-MM-dd hh:mm:ss')         "2017-02-28 09:24:00"
 * @example  dateFormat(new Date(),'hh:mm')                       "09:24"
 * @example  dateFormat(new Date(),'yyyy-MM-ddThh:mm:ss+08:00')   "2017-02-28T09:24:00+08:00"
 * @returns {boolean}
 */
export function dateFormat (dateStr, sFormat = 'yyyy-MM-dd') {
  let date = dateStr
  // console.log('00dateStr--->', dateStr)
  if(!(date instanceof Date)) {
    try {
      if(isEmpty(date)) {
        return ''
      }
      if(date.lastIndexOf('.') !== -1) {
        date = date.substr(0, date.lastIndexOf('.'))
      }
      // date = date.replace(/\-/g, '/') // eslint-disable-line
      // console.log('date11', date)
      if(date.indexOf('00:00:00') !== -1) {
        return date
      }
      date = new Date(date)
      if(!isValidDate(date)) {
        return dateStr
      }
    } catch (e) {
      console.log(e)
    }
  }

  let time = {
    Year: 0,
    TYear: '0',
    Month: 0,
    TMonth: '0',
    Day: 0,
    TDay: '0',
    Hour: 0,
    THour: '0',
    hour: 0,
    Thour: '0',
    Minute: 0,
    TMinute: '0',
    Second: 0,
    TSecond: '0',
    Millisecond: 0,
  }
  time.Year = date.getFullYear()
  time.TYear = String(time.Year).substr(2)
  time.Month = date.getMonth() + 1
  time.TMonth = time.Month < 10 ? '0' + time.Month : String(time.Month)

  time.Day = date.getDate()
  time.TDay = time.Day < 10 ? '0' + time.Day : String(time.Day)

  time.Hour = date.getHours()
  time.THour = time.Hour < 10 ? '0' + time.Hour : String(time.Hour)
  // time.hour = time.Hour < 13 ? time.Hour : time.Hour - 12
  time.hour = time.Hour
  time.Thour = time.hour < 10 ? '0' + time.hour : String(time.hour)

  time.Minute = date.getMinutes()
  time.TMinute = time.Minute < 10 ? '0' + time.Minute : String(time.Minute)
  time.Second = date.getSeconds()
  time.TSecond = time.Second < 10 ? '0' + time.Second : String(time.Second)
  time.Millisecond = date.getMilliseconds()

  return sFormat.replace(/yyyy/ig, String(time.Year))
    .replace(/yyy/ig, String(time.Year))
    .replace(/yy/ig, time.TYear)
    .replace(/y/ig, time.TYear)

    .replace(/MM/g, time.TMonth)
    .replace(/M/g, String(time.Month))

    .replace(/dd/ig, time.TDay)
    .replace(/d/ig, String(time.Day))

    .replace(/HH/g, time.THour)
    .replace(/H/g, String(time.Hour))
    .replace(/hh/g, time.Thour)
    .replace(/h/g, String(time.hour))

    .replace(/mm/g, time.TMinute)
    .replace(/m/g, String(time.Minute))
    .replace(/ss/ig, time.TSecond)
    .replace(/s/ig, String(time.Second))
    .replace(/fff/ig, String(time.Millisecond))
}
/**
 * @method 移除json中为空的数据
 * @param {*json参数} params
 */
export function rmEmptyValueFromJson (params) {
  let jsonParams = JSON.parse(JSON.stringify(params))
  for(let key in params) {
    if(isEmpty(params[key])) {
      delete jsonParams[key]
    }
  }
  return jsonParams
}

/**
 * @method 从url根据name获取参数,
 * @param name
 * @returns {string}
 */
export function getQueryStringByName (name) {
  let url = window.location.href
  // const rulSubstr = url.substr(0, 16)
  // 防止页面url增加#字符串
  if(url.indexOf('#')) {
    url = url.split('#')[0]
  }
  // console.log('处理#之后的url======================' + JSON.stringify(url))
  // if(rulSubstr === 'http://localhost' || url.indexOf(name) === -1) {
  if(url.indexOf(name) === -1) {
    return ''
  } else {
    const obj = {}
    const arr1 = url.split('?')
    const arr2 = arr1[1].split('&')
    for(let i = 0; i < arr2.length; i++) {
      const res = arr2[i].split('=')
      obj[res[0]] = res[1]
    }
    return obj[name]
  }
}
/**
 * @method 获取登陆url
 */
export function getLoginUrl () {
  // return process.env.NODE_ENV === 'development' ? '' : process.env.LOGIN_URL
  return ''
}
/**
 * @method 获取普通接口url
 */
export function getApiUrl () {
  // return process.env.NODE_ENV === 'development' ? '' : process.env.BASE_URL
  return ''
}

/**
 * @method 判断是否为合法日期
 * @param date 为Date转化后的值
 */
function isValidDate (date) {
  return date instanceof Date && !isNaN(date.getTime())
}

/**
 * @method 使用store缓存一些数据
 * @param module 实体
 * @param key 存的键
 * @param value 存的值
 */
export function setStoreInfo (module, key, value) {
  store.commit('setValue', {
    module: [module],
    key: key,
    value: value,
  })
}
/**
 * @method 获取store缓存的数据
 * @param module 实体
 * @param key 存的键
 * @param value 存的值
 */
export function getStoreInfo (module, key) {
  let storeObj = store.state[module]
  if(isEmpty(storeObj)) {
    return ''
  }
  return storeObj[key]
}

/**
 * @method 计算俩日期相隔天数
 * @param sDate1 开始日期
 * @param sDate2 结束日期
 */
export function dateDiff (sDate1, sDate2) {
  var dateSpan, iDays
  sDate1 = Date.parse(sDate1)
  sDate2 = Date.parse(sDate2)
  dateSpan = sDate2 - sDate1
  dateSpan = Math.abs(dateSpan)
  iDays = Math.floor(dateSpan / (24 * 3600 * 1000))
  return (iDays + 1)
}

export function isNumber (obj) {
  var reg = /^[0-9]+.?[0-9]*$/
  if(reg.test(obj)) {
    return true
  }
  return false
}

export function toNum (obj) {
  var reg = /^[0-9]+.?[0-9]*$/
  if(reg.test(obj)) {
    return parseInt(obj)
  }
  return -1
}

/**
 * 根据条件获取列表数据
 * @param {tcode} tcode
 * @param {参数1} p1
 * @param {成功callback} success
 * @param {失败callback} error
 */
export function getDataListById (tcode, p1, success, error) {
  let params = {
    p1: p1,
    tcode: tcode,
  }
  $appForm
    .hdList(params)
    .then((res) => {
      let resData = res.data || {}
      if(resData.code === '10') {
        success(resData)
      } else {
        error(resData)
        console.error(resData)
      }
    })
    .catch((err) => {
      this.transFormErrorMsg(err)
    })
}

/**
 * 根据条件获取表单数据
 * @param {tcode} tcode
 * @param {参数1} id
 * @param {成功callback} success
 * @param {失败callback} error
 */
export function getDataFormById (tcode, id, success, error) {
  let params = {
    id: id,
    tcode: tcode,
  }
  $appForm
    .hdForm(params)
    .then((res) => {
      let resData = res.data || {}
      if(resData.code === '10') {
        success(resData)
      } else {
        error(resData)
        console.error(resData)
      }
    })
    .catch((err) => {
      this.transFormErrorMsg(err)
    })
}

/**
 * 根据id获取单条记录信息
 * @param {tcode} tcode
 * @param {实体id} entityId
 * @param {成功callback} success
 * @param {失败callback} error
 */
export async function getEntityInfoById (tcode, entityId, success, error) {
  let params = {
    id: entityId,
    tcode: tcode,
  }
  await $appForm
    .hdForm(params)
    .then((res) => {
      let resData = res.data || {}
      if(resData.code === '10') {
        success(resData)
      } else {
        console.error(resData)
      }
    })
    .catch((err) => {
      error(err)
    })
}



// WEBPACK FOOTER //
// ./src/utils/commonUtil.js